import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "react-router-redux";
import { Provider } from "react-redux";
import createRootReducer from "./reducers";
import thunk from "redux-thunk";
import App from "./components/App";
import "./static/css/App.css";
import { unregister } from "./registerServiceWorker";

//Froala Editor Set up
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "font-awesome/css/font-awesome.css";
import $ from "jquery";
window.$ = $;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const history = createBrowserHistory();

const middleware = [thunk, routerMiddleware(history)];

const store = createStore(
  createRootReducer(history),
  {},
  composeEnhancers(applyMiddleware(...middleware))
);

// const ErrorBoundary = bugsnagClient.use(createPlugin(React));
ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById("root")
);

unregister();
